import React from 'react'

import styled from 'styled-components'
import {media} from 'styled-bootstrap-grid'
import {format as formatSSN} from 'kennitala'

import type {Address} from 'src/api/saleor/generated'
import {P} from 'src/components/typography'
import InfoCard from 'src/components/account/InfoCard'
import {RadioButton} from 'src/components/form'
import {formatPhoneNumber} from 'src/utils/strings'

interface Props {
  address: Address
  selected?: boolean
  onSelect: () => void
  onDelete: () => void
  cornerButton?: boolean
  icon: React.ReactElement
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
`

const RadioContainer = styled.div`
  width: 40px;
  min-width: 40px;
  display: none;
  align-items: center;

  ${media.md`
    width: 56px;
    min-width: 56px;
    display: flex;
  `}
`

export default function ReceiverCard({
  address,
  selected,
  onSelect,
  onDelete,
  cornerButton,
  icon,
}: Props): JSX.Element {
  const {
    firstName,
    lastName,
    streetAddress1,
    postalCode,
    city,
    phone,
    companyName,
  } = address

  return (
    <Wrapper>
      <RadioContainer>
        <RadioButton checked={selected} onChange={onSelect} />
      </RadioContainer>
      <InfoCard
        icon={icon}
        selected={selected}
        onSelect={onSelect}
        deleteIcon
        title={firstName || companyName}
        description={
          <>
            <P>{lastName && formatSSN(lastName)}</P>
            {phone ? <P>{formatPhoneNumber(phone)}</P> : null}
            <P>{streetAddress1},</P>
            <P>
              {postalCode} {city}
            </P>
          </>
        }
        cornerButton={cornerButton}
        handleDelete={onDelete}
        pointerCursor
      />
    </Wrapper>
  )
}
